import type { SchemaField } from '@cli-types/core-engine/schema.js'
import {
  GENERATED_SCHEMA_TITLE_FIELD_NAME,
  GENERATED_SCHEMA_TITLE_FIELD_TYPES
} from '@cli-constants/schema.js'

export function isGeneratedSchemaTitleField(field: SchemaField): boolean {
  return (
    field.name === GENERATED_SCHEMA_TITLE_FIELD_NAME &&
    GENERATED_SCHEMA_TITLE_FIELD_TYPES.has(field.type)
  )
}
